import React, { useState } from "react";
import DeleteButton from "../Buttons/DeleteButton";
import EditButton from "../Buttons/EditButton";
import DateAndTimeChip from "../Chips/DateAndTimeChip";
import { Box, Modal } from "@mui/material";
import EditGroupNote from "./EditGroupNotes";
import DeleteNote from "./DeleteNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import ViewGroupNotes from "./ViewGroupNotes";
import Tooltip from "@mui/material/Tooltip";
import "./GroupNoteContainerRedesign.css";

function GroupNoteContainer(props) {
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const attendeesText =
    (props.attendeesDetails?.length
      ? props.attendeesDetails
          .map((a) => a?.name || a?.id)
          .filter(Boolean)
          .join(", ")
      : props.attendees?.length
      ? props.attendees.join(", ")
      : null) || "—";

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const openEditModal = () => {
    setShowEditModal(true);
  };
  const closeEditModal = () => {
    setShowEditModal(false);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min(900px, calc(100vw - 32px))",
    maxHeight: "88vh",
    borderRadius: 3,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    overflow: "hidden",
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <EditGroupNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDateTime={props.effectiveDateTime}
            closemodal={closeEditModal}
            {...props}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <ViewGroupNotes
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDateTime={props.effectiveDateTime}
            closemodal={closeViewModal}
            {...props}
          />
        </Box>
      </Modal>

      <article className="group-note-summary-card">
        <div className="group-note-summary-top">
          <div className="group-note-summary-chips">
            <DateAndTimeChip date={props.noteDate} />
            <DateAndTimeChip date={props.noteTime} />
            <TypeNoteChip noteType={props.noteType} />
          </div>

          <div className="group-note-summary-actions">
            <EditButton handleOpen={openEditModal} />
            <DeleteButton handleOpen={openDeleteModal} />
          </div>
        </div>

        <div className="group-note-summary-meta">
          <div className="group-note-summary-meta-item">
            <span>Done by</span>
            <strong>{props.doneBy || "-"}</strong>
          </div>

          <div className="group-note-summary-meta-item">
            <span>Recorded</span>
            <strong>{props.timeStamp || "-"}</strong>
          </div>

          <div className="group-note-summary-meta-item">
            <span>Group topic</span>
            <strong>{props.groupTopic || "-"}</strong>
          </div>

          <div className="group-note-summary-meta-item">
            <span>Group type</span>
            <strong>
              {props.groupType === "Other"
                ? props.otherTypeGroupNote || "Other"
                : props.groupType || "-"}
            </strong>
          </div>

          <Tooltip title={attendeesText} arrow placement="top-start">
            <div className="group-note-summary-meta-item group-note-summary-attendees">
              <span>Attendance</span>
              <strong>{attendeesText}</strong>
            </div>
          </Tooltip>
        </div>

        <div className="group-note-summary-content">
          {props.noteContent || "No note content."}
        </div>
      </article>
    </div>
  );
}

export default GroupNoteContainer;




